import React from "react";
import { Tooltip } from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const CustomToolTip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "#FFF",
    maxWidth: 220,
    minHeight: 30,
    marginTop: "0px !important",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    transform: "translateX(-60%) translateY(-106%) !important",
  },
}));

export default CustomToolTip;
